define('modules/base/drawer/views/base.integration.drawer',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    'modules/base/views/model.view'
], function(
    Prospector,
    $, _,Backbone,
    ModelView,
    Template
){
    var BaseIntegrationDrawer = ModelView.extend({
        className: 'row',
        loader: '',
        sessionCheckProperty: 'hasActiveSession',
        initialize: function(options) {
            this.parent = options.parent;
            ModelView.prototype.initialize.call(this, options);
        },
        onRender:function(){
            if(this.model.has(this.sessionCheckProperty)){
                this.procResponse();
            } else {
                ModelView.prototype.onRender.call(this);
            }
        },
        procResponse:function(){
            this.displayView = null;
            if(this.model.has(this.sessionCheckProperty) && this.model.get(this.sessionCheckProperty)){
                this.passActiveSession();
                this.buildExportView();
            }  else {
                this.buildLinkView();
            }
            $(this.el).empty().append(this.displayView.render().el);
        },
        passActiveSession:function(){
        },
        failedActiveSession:function(){
        },
        buildExportView:function(){
        },
        buildLinkView:function(){
        }
    });
    return BaseIntegrationDrawer;
});
